import { render, staticRenderFns } from "./HeadItemTwo.vue?vue&type=template&id=7771065a&scoped=true"
import script from "./HeadItemTwo.vue?vue&type=script&lang=js"
export * from "./HeadItemTwo.vue?vue&type=script&lang=js"
import style0 from "./HeadItemTwo.vue?vue&type=style&index=0&id=7771065a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7771065a",
  null
  
)

export default component.exports